module.exports = __webpack_public_path__ + "img/emoji-devil.6e1ef2b8.svg";